<template>
    <v-layout column>
      <v-flex>
        <upcoming-event />
      </v-flex>
      <v-flex xs12>
        <related-networks
          class="panelBlock"
          :can-view-sub-networks="true"
        />
      </v-flex>
    </v-layout>
  </template>
  

<script>
    import UpcomingEvent from '@/components/ChapterPage/UpcomingEvents/UpcomingEvent';
    import { upcomingEventsConstant } from '@/components/ChapterPage/communityCommon.constant';
    import RelatedNetworks from '../NetworkPage/RelatedNetworks.vue';

    export default {
        name: "CommunityRightSidebar",
        components: {
            UpcomingEvent,
            RelatedNetworks,
        },
        data() {
            return {
                upcomingEventsConstant,
            };
        },
    };
</script>

<style lang="scss" scoped>

</style>
